// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"950831a7","416":"6026cb22","561":"f3a919ec","676":"424750fa","829":"47fb9239","882":"3cfd8dd4","886":"004dcbd8"}[chunkId] + ".chunk.js";
};